/**
 * Interface Segregation Principle - Define minimal validator interface
 */
export class IValidator {
  validate(id) {
    throw new Error('validate method must be implemented');
  }
}